///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

// Function to handle converting the CSV to the AutoComplete Options
// Aka converts { AL, PA } to the objects Alabama and PA to populate the autocomplete on load
export const convertFromCSVToArray = (inputCSV, autoCompleteOptions) => {
  let selectedValues = [];

  if (inputCSV && inputCSV.length > 0) {
    let csvValues = inputCSV.split(',');

    for (const individualValues in csvValues) {
      let autoCompleteFilteredOption = autoCompleteOptions.filter(obj => {
        return obj.id == csvValues[individualValues]
      });

      if (autoCompleteFilteredOption && autoCompleteFilteredOption.length > 0) {
        selectedValues.push(autoCompleteFilteredOption[0]);
      }
    }
  }

  return selectedValues;
}

// Function to convert our selected values back to a CSV to be used by the react state
export const csvSelections = (selectedValues) => {
  if (selectedValues && selectedValues.length > 0) {
    return [...selectedValues.map(item => item.id)].join(',');
  }

  return null;
}
